export const GUIDE = {
  eyebrow: "A free gift from DJ",
  title: "The Metabolism Reset Guide",
  subtitle: "5 signs your metabolism is asking for help — and the first 3 steps to heal it.",
  intro:
    "If you're eating less and moving more but your body refuses to change, you are not lazy and you are not broken. Your metabolism is protecting you — and it's speaking to you every single day. This guide will teach you how to listen.",
  signsTitle: "5 signs your metabolism needs healing",
  signs: [
    {
      title: "You're exhausted no matter how much you sleep",
      body: "Waking up tired, crashing at 3pm, needing caffeine to function — this is not normal, and it's not a willpower problem. Chronic fatigue is your body down-regulating energy output because it doesn't feel safe.",
    },
    {
      title: "You eat clean, but the scale won't move",
      body: "Years of dieting teach your body to survive on less. When your intake stays low for too long, your metabolism adapts downward — so the harder you restrict, the harder your body holds on.",
    },
    {
      title: "Your cycle, mood, or sleep feels off",
      body: "Hormones are the messengers of your metabolism. Irregular cycles, low libido, anxiety, 3am wake-ups — these are metabolic signals, not personality flaws.",
    },
    {
      title: "You're cold, puffy, or bloated for no reason",
      body: "Cold hands and feet, water retention, digestive drama after 'safe' foods — all point to a stressed system running on survival mode instead of thriving mode.",
    },
    {
      title: "Cravings run the show after dark",
      body: "Intense evening sugar or salt cravings usually mean under-eating during the day, blood sugar swings, and a nervous system begging for quick fuel. It's biology — not a lack of discipline.",
    },
  ],
  stepsTitle: "Your first 3 steps",
  steps: [
    {
      title: "Eat a real breakfast within an hour of waking",
      body: "Protein first — 30g or more, with real carbohydrates and salt. This one habit begins to stabilize cortisol and blood sugar, which tells your body it's safe to burn instead of store.",
    },
    {
      title: "Walk before you run",
      body: "Trade punishing cardio for 8–10k daily steps and 3 days of strength training. Muscle is your metabolic engine — walking calms your nervous system while strength rebuilds the engine.",
    },
    {
      title: "Stop eating like it's a punishment",
      body: "Fuel consistently: three real meals, no 6-hour gaps, no 'earning' your food. Consistency — not restriction — is what convinces your metabolism it can finally come out of survival mode.",
    },
  ],
  closing:
    "These three steps are the beginning — the same foundation every woman inside the Metabolic Transformation Method starts with. Healing your metabolism isn't about doing more. It's about doing the right things, in the right order, with the right support.",
  ctaLabel: "Apply for the Metabolic Transformation Method",
};
